<template>
<main>
<header>
</header>
  <div id="tabHead">
    <div id="selectAction">
        <select class="selAction" name="selectAction" v-model="logAction">
          <option value="NONE">Do nothing</option>
          <option value="WIP">WIP - Run job again</option>
          <option value="SEND2CB">SEND2CB - send latest wrk-response back to main app</option>
        </select>
    </div>
    <div id="tabH">
        <table-lite
          :is-hide-paging= "true"
          :columns=    "tabHead.columns"
          :rows=       "tabHead.rows"
          @row-clicked="rowClicked"
          >
        </table-lite>
    </div>
  </div>
  <div id="tabLogs">
    <table-lite
    :is-hide-paging= "true"
    :columns=    "tabLogs.columns"
    :rows=       "tabLogs.rows"
    :row-classes="tabLogs.rowClasses"
    :is-loading= "tabLogs.isLoading"
    :sortable=   "tabLogs.sortable"
    @row-clicked="rowClicked"
    @is-finished="tableLoadingFinish"
    >
    </table-lite>
  </div>
</main>
</template>

<script>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, onErrorCaptured } from 'vue'
import TableLite from "vue3-table-lite";

export default {
  name: 'LogComponent',
  components: {TableLite},
  props: {
    workerID:   {type: Number, required: true },
    workerData: {type: Object, required: true },
  },
  emits: ['update:logAction'],

  setup(props, { emit }) {
    // Reactive data - convert from data() function
    const wrkAction = ref('NONE')
    const jobID = ref(null)
    
    const tabHead = reactive({
      isLoading: false,
      totalRecordCount: 0,
      rows: [],
      columns: [
        { label: 'jobID', field: 'jobID', isKey: true, width: "5%" },
        { label: 'action', field: 'action' },
        { label: 'status', field: 'status' },
        { label: 'created', field: 'created' },
        { label: 'updated', field: 'updated' },
        { label: 'updCounter', field: 'updCounter', width: "5%" }
      ]
    })

    const tabLogs = reactive({
      isLoading: true,
      totalRecordCount: 0,
      sortable: { created: "id", sort: "asc" },
      rows: [],
      rowClasses: (row) => {
        return row.status === 'INIT' ? ['rowINIT'] :
               row.status.startsWith('MONITOR') ? ['rowMONITOR'] : [];
      },
      columns: [
        { 
          label: 'Del', 
          field: 'id', 
          width: "5%",
          sortable: false,
          display: function (row) {
            const delImg = new URL('@/assets/delete.png', import.meta.url).href;
            return `<img src="${delImg}" data-id="${row.id}" class="is-rows-el delIcon" />`;
          }
        },
        { label: 'id', field: 'id', isKey: true, width: "5%" },
        { label: 'status', field: 'status' },
        { label: 'message', field: 'message', width: "50%" },
        { label: 'created', field: 'created', sortable: true }
      ]
    })

    // Computed properties - convert from computed object
    const tabHeadRows = computed(() => {
      return props.workerData?.head ? [props.workerData.head] : [];
    })
    
    const tabLogsRows = computed(() => {
      return props.workerData?.logs || [];
    })

    // For the logAction computed with getter/setter, we need to create a custom v-model
    const logAction = computed({
      get: () => wrkAction.value,
      set: (val) => {
        emit('update:logAction', { 
          jobID: jobID.value, 
          action: val, 
          workerID: props.workerID 
        });
      }
    })
    
    // Update watchers to modify reactive object properties
    watch(tabHeadRows, (newRows) => {
      tabHead.rows = newRows;
      jobID.value = newRows?.[0]?.jobID;
    }, { immediate: true })
    
    watch(tabLogsRows, (newRows) => {
      tabLogs.rows = newRows;
    }, { immediate: true })

    // Methods - convert from methods object
    const rowClicked = (row) => { 
      console.log("Row clicked!", row); 
    }

    const tableLoadingFinish = (elements) => {
      tabLogs.isLoading = false;
      Array.prototype.forEach.call(elements, function (element) {
        if (element.classList.contains("delIcon")) {
          element.addEventListener("click", function () {
            window.dispatchEvent(new CustomEvent('callHandleDelete', {detail: this.dataset.id}));
            this.classList.toggle('shrink');
          });
        }
      });
    }

    const handleDelete = (event) => {
      emit('update:logAction', {
        jobID: jobID.value,
        action: 'DELWRKLOG',
        workerID: props.workerID,
        id: event.detail * 1
      });
    }

    // Lifecycle hooks - convert from mounted/beforeUnmount/errorCaptured
    onErrorCaptured((err, instance, msg) => {
      console.log('errorCaptured', err, msg);
    })

    onMounted(() => {
      window.addEventListener('callHandleDelete', handleDelete);
    })

    onBeforeUnmount(() => {
      window.removeEventListener('callHandleDelete', handleDelete);
    })

    return {
      wrkAction,
      jobID,
      tabHead,
      tabLogs,
      logAction,
      rowClicked,
      tableLoadingFinish,
      handleDelete
    }
  }
}
</script>

<!-- <style scoped> -->
<style>
@keyframes shrinkAnim {
      0%   { width: 16px; }
      50%  { width: 10px; }
      100% { width: 16px; }
}
.shrink {
    animation: shrinkAnim 2s infinite;
    height: auto;
}
</style>
<style scoped>
#tabHead { width: 50%; }
::v-deep(.rowMONITOR) { background: #215f5e !important; }
::v-deep(.rowINIT)    { background: #5c2121 !important; }
::v-deep(.delIcon) {width: 16px; }
</style>